<template>
    <TsCard no-border no-shadow>
        <div class=" rounded-full p-2 max-w-max mx-auto p-3 bg-white">
            <TsImage class="flex mx-auto" v-if="image" :src="image" :alt="alt" width="35" height="35" loading="lazy"/>
        </div>
        <TsTypography appendClass="text-center mt-2" as="h2">{{ heading }}</TsTypography>
        <TsTypography>
            {{ description }}
        </TsTypography>
    </TsCard>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
    heading: string;
    image: string;
    alt:string;
    description: string;
}
const props = withDefaults(defineProps<Props>(), {
    heading: 'John Carter',
    image: '/images/Digitalnomad.png',
    alt:'benifit',
    description: 'Our offices and facilities are equipped with modern amenities and tools to create a comfortable and productive work environment. Enjoy state-of-the-art equipment and ergonomic workstations.'
});
</script>